export default "__VITE_ASSET__pk5iQag0__"